interface IFinanceMortgageUrl {
  search?: string | null;
}

export function getFinanceMortgageUrl({ search }: IFinanceMortgageUrl): string {
  const searchParams = new URLSearchParams(search || '');
  const returnUrl = searchParams.get('returnUrl');

  if (returnUrl) {
    return returnUrl;
  }

  searchParams.append('skip_welcome_page', 'true');

  return `https://www.cian.ru/cf/user-state-machine/route/entrypoint/?${searchParams}`;
}
